import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { getConfig } from "../config";

export const AuthProvider = ({ children }: { children: ReactNode }) => {
	const navigate = useNavigate();
	const onRedirectCallback = (appState?: AppState) => {
		sessionStorage.clear();
		navigate(appState?.returnTo || window.location.pathname);
	};

	const config = getConfig();
	if (!config.auth0Domain || !config.auth0ClientId || !config.auth0Audience) {
		throw new Error("Auth configuration is not set");
	}

	return (
		<Auth0Provider
			domain={config.auth0Domain}
			clientId={config.auth0ClientId}
			authorizationParams={{
				audience: config.auth0Audience,
				redirect_uri: `${window.location.origin}/`,
				scope: "openid profile email offline_access",
			}}
			onRedirectCallback={onRedirectCallback}
			useRefreshTokens
			useRefreshTokensFallback
		>
			{children}
		</Auth0Provider>
	);
};
